import {IonContent, IonHeader, IonPage} from '@ionic/react';
import './HomePage.css';
import AppToolbar from "../../components/utils/AppToolbar";
import React from "react";
import HomeButton from "../../components/home/HomeButton";
import {operationsWithIconUrls} from "../../models/utils/EOperationType";
import OperationLocalService from "../../services/storage/localStorage/OperationLocalService";
import StatsCard from "../../components/home/StatsCard";
import AlertTooManyAsync from "../../components/utils/alert/AlertTooManyAsync";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {}

/**
 * HomePage page giving access to all operations available on the application.
 * Corresponds to the first tab.
 * @author Alizée Grand
 * @version 1.2
 * @creation 13/08/2021
 * @last_update 17/01/2022
 **/
class HomePage extends React.Component<Props, {
    isAlertAsyncOpen: boolean
}> {

    constructor(props: Props) {
        super(props);
        const nbOperationsAsync = OperationLocalService.getOperationsBySync(false).length;
        this.state = {
            isAlertAsyncOpen: nbOperationsAsync > 100
        };
    }

    render() {

        const nbOperations = OperationLocalService.getOperations().length;
        const nbOperationsAsync = OperationLocalService.getOperationsBySync(false).length;
        const nbOperationsToday = OperationLocalService.getOperationsByDate(new Date()).length;

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (
            <IonPage>
                <IonHeader>
                    <AppToolbar appTitle={getTranslation("pages.home.titles.page")}/>
                </IonHeader>
                <IonContent fullscreen id="homeMainContainer">
                    <AlertTooManyAsync isOpen={this.state.isAlertAsyncOpen}/>
                    <h1 className="home-page-title">
                        {getTranslation("pages.home.titles.operations")}
                    </h1>
                    <div id="homeButtonContainer">
                        {
                            operationsWithIconUrls.map((operationWithIcon, index) => (
                                <HomeButton
                                    key={index}
                                    iconPath={operationWithIcon.iconPath}
                                    destination={operationWithIcon.link}
                                >
                                    {getTranslation(operationWithIcon.translateKeyName)}
                                </HomeButton>
                            ))
                        }
                    </div>
                    <h1 className="home-page-title">
                        {getTranslation("pages.home.titles.stats")}
                    </h1>
                    <div className="home-page-stats-container">
                        <StatsCard
                            nbToDisplay={nbOperations}
                            content={
                                nbOperations > 1 ? getTranslation("pages.home.stats.total.plural") : getTranslation("pages.home.stats.total.singular")
                            }
                        />
                        <StatsCard
                            nbToDisplay={nbOperationsAsync}
                            content={
                                nbOperationsAsync > 1 ? getTranslation("pages.home.stats.async.plural") : getTranslation("pages.home.stats.async.singular")
                            }
                        />
                        <StatsCard
                            nbToDisplay={nbOperationsToday}
                            content={
                                nbOperationsToday > 1 ? getTranslation("pages.home.stats.today.plural") : getTranslation("pages.home.stats.today.singular")
                            }
                        />
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withTranslation()(HomePage);
